import { render } from "./Collection.vue?vue&type=template&id=38e4dd04"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fa4daba7/0/develop/front_payments_config/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__